document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('FacetFiltersForm');
  if (form) {
    form.addEventListener('change', (event) => {
      const target = event.target;

      // Skip auto-submit if price range input triggered it
      if (target.id === 'custom-min-price' || target.id === 'custom-max-price') {
        return;
      }

      form.submit();
    });
  }
});
